import React, { useState, useEffect, useRef } from 'react';
import CircleButton from "../components/CircleButton";
import FooterPanel from "../components/FooterPanel";
import RetryPickles from '../assets/img/retry-pickles.png';
import styled from 'styled-components';
import parse from 'html-react-parser';
import ChantAudio1 from '../assets/audio/chant-1.mp3';
import ChantAudio2 from '../assets/audio/chant-2.mp3';
import ChantAudio3 from '../assets/audio/chant-3.mp3';
import MessageModal from '../components/MessageModal';

const StyledHeading = styled.h1`
  font-family: 'Speedee Bold';
  font-size: 72px;
  line-height: 0.95em;
  letter-spacing: -0.03em;
  margin: 0;
`;

const ChantText = styled.p`
  font-family: 'Speedee Bold';
  font-size: 33.82px;
  font-weight: bold;
  line-height: 0.95em;
  letter-spacing: -0.05em;
  margin: 70px 0 0 0;

  > span {
    color: #DB0007;
  }
`;

const ButtonText = styled.p`
  position: absolute;
  top: 40px;
  font-family: 'Speedee Bold';
  font-size: 20px;
  font-weight: bold;
  line-height: 0.95em;
  letter-spacing: -0.05em;
  margin: 26px 0 0 0;
`;

const TryAgainWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 56px);

  > img {
    &#img_pickles {
      position: absolute;
      top: -10px;
      right: -16px;
    }
  }
`;

const ListenChant = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none; 
  border-radius: 40px;
  background: #ebebeb;
  background-size: 100% 100%;
  padding: 4px 12px 4px 4px;
  font-size: 16px;
  line-height: 0.95;
  letter-spacing: -0.15px;
  margin: 24px 0 0 0;
  overflow-x: hidden;
  position: relative;
  color: #2D2D2D;

  svg {
    position: relative;
    z-index: 1;
    path {
      &.playing {
        fill: #fff;
      }
    }
  }

  span {
    position: relative;
    z-index: 1;
    &.playding {
      color: #fff;
    }
  }

  .dark-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #2d2d2d;
    transform: translateX(-100%);
    z-index: 0;
  }

  &.playing {
    svg {
      position: relative;
      z-index: 1;
      path {
        fill: #fff;
      }
    }

    span {
      position: relative;
      z-index: 1;
      color: #fff;
    }
  }
  
  @keyframes InProgress {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(0);
    }
  }
  `;

  const audioFiles = [ChantAudio1, ChantAudio2, ChantAudio3];

function TryAgainTap({...props}) {
  const { setPage, tapOptions, setTapOptions, setTapPhrase, setAttemptCount } = props;
  const [ phraseResult, setPhraseResult ] = useState('');
  const chantAudioRef = useRef(null);
  const listenChantRef = useRef(null);
  const [currentAudio, setCurrentAudio] = useState(null);
  const [modalDetails, setModalDetails] = useState(false);
  const [revealModal, setRevealModal] = useState(false);

  useEffect(() => {
    const correctOptions = [
      {
        value: 'Two all-beef patties',
        formatted: 'Two all-beef patties,'
      },
      {
        value: 'Special sauce',
        formatted: 'special sauce,'
      },
      {
        value: 'Lettuce',
        formatted: 'lettuce,'
      },
      {
        value: 'Cheese',
        formatted: 'cheese,'
      },
      {
        value: 'Pickles',
        formatted: 'pickles,'
      },
      {
        value: 'Onions',
        formatted: 'onions'
      },
      {
        value: 'On a',
        formatted: 'on a'
      },
      {
        value: 'Sesame seed bun',
        formatted: 'sesame seed bun.'
      }
    ];

    if (phraseResult === '') {
      // Show entered phrase with incorrect words highlighted
      // tapOptions.forEach((currOption, i) => {
      //   if (currOption === correctOptions[i].formatted) {
      //     setPhraseResult(prev => prev + `${currOption} `);
      //   } else {
      //     setPhraseResult(prev => prev + `<span>${currOption}</span> `);
      //   }
      // });

      // Show correct phrase with incorrect words highlighted
      correctOptions.forEach((currOption, i) => {
        if (currOption.formatted === tapOptions[i]) {
          setPhraseResult(prev => prev + `${currOption.formatted} `);
        } else {
          setPhraseResult(prev => prev + `<span>${currOption.formatted}</span> `);
        }
      });
    }    
  }, [tapOptions, setPhraseResult, phraseResult]);

  const retryTap = () => {
    setPhraseResult('');
    setTapOptions([]);
    setTapPhrase('');
    setAttemptCount(prev => prev + 1);
    setPage('countdown-tap');
  };

  const listenChant = () => {
    const audioPath = getRandomAudio();
    setCurrentAudio(audioPath);
    if (chantAudioRef.current) {
      chantAudioRef.current.load();
      chantAudioRef.current.play().catch(error => {
        setModalDetails({
          title: 'Error',
          message: 'Error playing audio. Please refresh the page and allow access to the microphone.',
          action: {
            label: 'Okay',
            refreshPage: true
          }
        });
        setRevealModal(true);
    });
    }
    chantAudioRef.current.onplaying = () => {
      const audioDuration = chantAudioRef.current.duration;
      listenChantRef.current.classList.add('playing');
      listenChantRef.current.disabled = true;
      listenChantRef.current.querySelector('.dark-bg').style.animation = `InProgress ${audioDuration}s linear backwards`;
    }
    chantAudioRef.current.onended = () => {
      listenChantRef.current.classList.remove('playing');
      listenChantRef.current.disabled = false;
      listenChantRef.current.querySelector('.dark-bg').style.animation = '';
    }
  }

  const getRandomAudio = () => {
    return audioFiles[Math.floor(Math.random() * audioFiles.length)];
  }
  
  return (
    <TryAgainWrapper>
      <div style={{ position: 'relative' }}>
        <StyledHeading>So close!</StyledHeading>
        <p>Listen to the chant again and<br/>have another go.</p>
        <ListenChant onClick={listenChant} ref={listenChantRef} >
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M5.73828 17.416H8.22559C8.2959 17.416 8.36621 17.4336 8.41895 17.4863L12.2773 20.9316C12.7344 21.3447 13.0859 21.5381 13.5518 21.5381C14.2021 21.5381 14.6943 21.0459 14.6943 20.3955V6.97461C14.6943 6.31543 14.2021 5.78809 13.5342 5.78809C13.0859 5.78809 12.7695 5.99023 12.2773 6.43848L8.41895 9.85742C8.36621 9.91016 8.2959 9.92773 8.22559 9.92773H5.73828C4.4375 9.92773 3.77832 10.6133 3.77832 11.9844V15.3594C3.77832 16.7393 4.44629 17.416 5.73828 17.416ZM21.2246 19.9297C21.6289 20.1758 22.1211 20.0879 22.4023 19.6748C23.5449 18.0576 24.2129 15.8867 24.2129 13.6543C24.2129 11.4219 23.5537 9.24219 22.4023 7.63379C22.1211 7.2207 21.6289 7.12402 21.2246 7.37891C20.8027 7.64258 20.7412 8.16992 21.0576 8.63574C21.9893 10.0068 22.5254 11.791 22.5254 13.6543C22.5254 15.5088 21.9805 17.293 21.0576 18.6729C20.75 19.1387 20.8027 19.6572 21.2246 19.9297ZM5.89648 15.8428C5.60645 15.8428 5.46582 15.7021 5.46582 15.4121V11.9404C5.46582 11.6416 5.60645 11.501 5.89648 11.501H8.63867C8.87598 11.501 9.05176 11.457 9.25391 11.2725L12.752 8.08203C12.7959 8.04688 12.8398 8.02051 12.8926 8.02051C12.9629 8.02051 13.0156 8.06445 13.0156 8.14355V19.1738C13.0156 19.2617 12.9629 19.3057 12.9014 19.3057C12.8486 19.3057 12.8047 19.2881 12.752 19.2441L9.25391 16.0713C9.05176 15.8867 8.87598 15.8428 8.63867 15.8428H5.89648ZM17.6914 17.5742C18.0693 17.8203 18.5615 17.7324 18.834 17.3457C19.5459 16.3965 19.9678 15.0518 19.9678 13.6543C19.9678 12.2568 19.5459 10.9209 18.834 9.96289C18.5615 9.57617 18.0693 9.48828 17.6914 9.74316C17.2607 10.0244 17.1729 10.543 17.5244 11.0527C18.0078 11.7471 18.2803 12.6787 18.2803 13.6543C18.2803 14.6299 17.999 15.5527 17.5244 16.2559C17.1816 16.7656 17.2607 17.2842 17.6914 17.5742Z" fill="#2D2D2D"/>
          </svg>
          <span>Listen to the chant</span>   
          <div className='dark-bg'></div>
          <audio ref={chantAudioRef}>
            <source src={currentAudio} type="audio/mpeg"/>
            Your browser does not support the audio element.
          </audio>       
        </ListenChant>
        <ChantText>{parse(phraseResult)}</ChantText>
      </div>
      <img id="img_pickles" src={RetryPickles} alt="Pickles"/>
      <FooterPanel>
        <CircleButton onClick={retryTap}>
          <svg width="32" height="35" viewBox="0 0 32 35" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.9845 35.0016C24.5275 35.0016 31.5788 27.9503 31.5788 19.4073C31.5788 11.9341 26.1698 5.60597 19.1034 4.14447V1.92963C19.1034 0.784541 18.2446 0.453068 17.3104 1.13108L12.2178 4.73209C11.4494 5.28956 11.4494 6.13331 12.2178 6.67572L17.2953 10.2918C18.2295 10.9698 19.1034 10.6685 19.1034 9.49325V7.3236C24.4973 8.6947 28.4449 13.5613 28.4449 19.4073C28.4449 26.323 22.9003 31.8828 15.9845 31.8828C9.06878 31.8828 3.50907 26.323 3.52414 19.4073C3.5392 15.3844 5.42257 11.8738 8.3757 9.59872C9.08385 8.98097 9.30985 8.09202 8.76744 7.35374C8.27023 6.64559 7.29088 6.52505 6.47726 7.188C2.81599 9.93019 0.405273 14.5407 0.405273 19.4073C0.405273 27.9503 7.45661 35.0016 15.9845 35.0016Z" fill="white"/>
          </svg>
        </CircleButton>
        <ButtonText>Try again</ButtonText>
      </FooterPanel>
      { revealModal && (
        <MessageModal details={modalDetails} setRevealModal={setRevealModal} />
      ) }
    </TryAgainWrapper>
  );
}

export default TryAgainTap;